export default __webpack_public_path__ + "assets/iraq-flag.png";